export const I18N = {
  en: {
    ARTCILES: "Articles",
    Official: "Official",
    Manager: "Manager",
    "Legal Reprentative": "Legal Reprentative",
    "Organization roles": "Organization roles",
    "Blog roles": "Blog roles",
    "Editor-in-chief": "Editor-in-chief",
    CHIEF_EDITOR: "CHIEF EDITOR",
    AUTHOR: "AUTHOR",
    REDACTOR: "REDACTOR",
    LEGAL_REPRESENTATIVE: "LEGAL REPRESENTATIVE",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIAL",
    SHAREHOLDER: "SHAREHOLDER",
    QUALITY_MANAGER: "QUALITY MANAGER",
    EXTERNAL: "EXTERNAL",
    Mandated: "Mandated",
    Not_Mandated: "Not Mandated",
    Details: "Details",
    Join: "Join",
    Replay: "Replay",
    Purchase: "Purchase",
    "Possible to review the training for max 15 days after the date of the live":
      "Possible to review the training for max 15 days after the date of the live",
    Webinar: "Webinar",
    "In progress": "In progress",
    "Certificate included approved by": "Certificate included approved by",
    "En Live": "Live",
    see_version: "See version",
    atText: "at",
    publishedOn: "Published on",
    reading: "Reading",
    noOptions: "no options",
    sharedWith: "share with",
    share: "Share",
    "En Replay": "En Replay",
    add: "Add",
    quote_text: "Insert quote text",
    quote_author: "Insert quote author",
    offfcourse_library: "oFFFcourse lib",
    replayExpired: "Replay expired",
    review: "Review",
    resume: "Resume",
    play: "Play",
    rejoin: "Rejoin",
    participate: "Participate",
    buy: "Buy",
    details: "Details",
    free: "Free",
    subscribed: "You are subscribed",
    subscribedPremium: "Premium subscriber",
    forTheMembers: "for the members",
    inReplay: "In Replay",
    liveNow: "live now",
    seen: "Already Seen",
    presential: "On the spot",
    hybrid: "Hybrid",
    inLive: "In live",
    dateFrom: "From",
    timeTo: "to",
    dateTo: "to",
    errorOccurred: "Error occurred",
    includedPremium: "Included in premium",
    soldOut: "Sold out",
    d: "d",
    h: "h",
    m: "m",
    s: "s",
    includedInSeason: "Included in season",
    includedInCycle: "Included in cycle",
    inPresential: "On the spot",
    live: "LIVE",
    replay: "REPLAY",
    hourAbr: "h",
    hours: "hours",
    minutes: "minutes",
    and: "and",
    trainings: "Trainings",
    ofCertifiedAttestations: "of certified attestations",
    season: "Season",
    essential: "Essential",
    cycle: "Cycle",
    congress: "Congress",
    soonLive: "Coming soon live",
    soonInPerson: "Coming soon in person",
    registerNow: "Register now",
    register: "Register",
    buyTraining: "Buy training",
    moreDetails: "More details",
    program: "Program",
    buyTheCycle: "Buy the cycle",
    buyTheSeason: "Buy the season",
    buyTheEssential: "Buy the essential",
    alreadyPremiumSubscribed: "You are a premium subscriber",
    premiumSubscription: "premium subscription",
    premiumDescription:
      "Live & Replay access to the entire OfffCourse library*",
    subscribeToPremium: "Subscribe to Premium",
    containsExclusiveEvents:
      "* Includes exclusively all oFFFcourse virtual courses",
    twelveMonthsCommitment: "For 12 months, with commitment",
    year: "year",
    month: "month",
    monthly: "Monthly",
    yearly: "Yearly",
    saveAmount: "save",
    buyCycle: "Buy {{definiteLabel}}",
    premiumLabel: "Benefit from over 500 training courses",
    auth: {
      signInUp: "Login / Register",
      continue: "Continue",
      signup: "Register",
      signin: "Log in",
      forgotPassword: "Forgot Password",
      forgot_password: "Forgot?",
      must_accept_conditions: "You must accept our terms of use",
      already_member: "Already a member?",
      server_error: "Server unreachable - Try again later",
      error_occurred: "An error has occurred!",
      invalid_credentials: "Invalid credentials",
      email_address: "Email address",
      email: "Email",
      firstname: "First name",
      lastname: "Last name",
      validate_email: "Please provide a valid email address",
      validate_password: "Password is required",
      required_field: "This field is required",
      required_2_characters: "Please provide at least 2 characters",
      password_weak: "Password is weak!",
      password_not_match: "Please re-enter the same value",
      password: "Password",
      confirm_password: "Confirm password",
      init_password_p: "Logged in without password?",
      init_password_a: "Create or reset it here!",
      check_your_email:
        "Please check your email to validate your email address",
      already_sent_email:
        "We have already sent a confirmation email to your inbox.",
      resend_confirmation_email: "Resend confirmation email",
      create_account: "Create account",
      send: "Send",
      password_changed_succesfully: "Password successfully saved",
      reset_pwd_check_your_email:
        "A message has been sent to your inbox e-mail. Please review it and follow the instructions.",
      successfully_saved: "Successfully saved",
      complete_personal_infos: "Complete my personal account",
      mobile_phone_number: "Mobile Phone Number",
      email_validated_successfully: "Email address validated successfully",
      account_exist_login:
        "This account already exists in the Tamtam universe:<br/><ul><li><small>- oFFFcouse</small></li><li><small>- United Associates</small></li><li><small>- Forum For the Future</small></li></ul>Please enter your password",
      account_exist_pwd:
        "This account already exists in the Tamtam universe:<br/><ul><li><small>- oFFFcouse</small></li><li><small>- United Associates</small></li><li><small>- Forum For the Future</small></li></ul>Please set a password",
      validate: "Validate",
      male: "Man",
      female: "Woman",
      gender: "Gender",
      language: "Language",
      numeroAgreation: "Number of agreation (economic professions)",
      itaa: "ITAA fiduciary office",
      ire_audit: "IRE audit firm",
      law_office: "Law firm",
      notarial_office: "Notarial study firm",
      university: "University",
      other: "Others...",
      validate_phone: "The phone number is invalid",
      uen_label_number: "Enter the number",
      oldPassword_incorrect: "Old password is incorrect",
      email_not_unique: "Email address already taken",
      cancel: "Cancel",
      reset_password: "Set password",
      french: "French",
      dutch: "Dutch",
      new: "You have not yet account?",
      begin_by: "Start by yourself",
      subscribe: "sign up.",
      create_account_ok: "Creating an account means you agree to our ",
      term_of_use: "terms and conditions",
      logout: "Log out",
      invalid_code: "Invalid code",
      login_without_password: "Log in without password",
    },
    on: "on",
  },
  fr: {
    ARTCILES: "Articles",
    Official: "Officiel",
    Manager: "Directeur",
    "Legal Reprentative": "Représentant légal",
    "Organization roles": "Rôles de l'organisation",
    "Blog roles": "Rôles du blog",
    "Editor-in-chief": "Éditeur en chef",
    CHIEF_EDITOR: "Rédacteur en chef",
    AUTHOR: "Auteur",
    REDACTOR: "Rédacteur",
    LEGAL_REPRESENTATIVE: "REPRÉSENTANT LÉGAL",
    MANAGER: "GÉRANT",
    OFFICIAL: "OFFICIEL",
    SHAREHOLDER: "ACTIONNAIRE",
    QUALITY_MANAGER: "RESPONSABLE QUALITÉ",
    EXTERNAL: "EXTERNE",
    Mandated: "Mandaté",
    Not_Mandated: "Non Mandaté",
    Details: "Détails",
    Join: "Rejoindre",
    Replay: "Rejouer",
    Purchase: "Acheter",
    "Possible to review the training for max 15 days after the date of the live":
      "Possible de revoir la formation pendant max 15 jours après la date du live",
    Webinar: "Webinar",
    "In progress": "En cours",
    "Certificate included approved by": "Attestation incluse agréé par",
    "En Live": "En Live",
    see_version: "Voir version",
    atText: "à",
    publishedOn: "Publié le",
    reading: "Lecture de",
    noOptions: "aucune options",
    sharedWith: "partager avec",
    share: "Partager",
    "En Replay": "En Replay",
    add: "Ajouter",
    quote_text: "Insérer le texte de la citation",
    quote_author: "Insérer l'auteur de la citation",
    write_here: "Écrire ici ...",
    customize: "Personnaliser",
    customize_dynamic_fields: "Personnalisez avec des champs dynamiques",
    quiz: "Questionnaire",
    save: "Enregistrer",
    offfcourse_library: "oFFFcourse lib",
    replayExpired: "Replay expiré",
    review: "Revoir",
    resume: "Reprendre",
    play: "Lecture",
    rejoin: "Rejoindre",
    participate: "Participer",
    buy: "Acheter",
    details: "Détails",
    free: "Gratuit",
    subscribed: "Vous êtes inscrit",
    subscribedPremium: "Abonné premium",
    forTheMembers: "pour les membres",
    inReplay: "En Replay",
    liveNow: "en live maintenant",
    seen: "Déja Vu",
    presential: "En Présentiel",
    hybrid: "Hybride",
    inLive: "En live",
    dateFrom: "Du",
    timeTo: "à",
    dateTo: "au",
    errorOccurred: "Une erreur est survenue",
    includedPremium: "Inclus premium",
    soldOut: "Sold out",
    d: "j",
    h: "h",
    m: "m",
    s: "s",
    includedInSeason: "Fait partie d'une saison",
    includedInCycle: "Fait partie d'un cycle",
    inPresential: "Sur place",
    live: "LIVE",
    replay: "REPLAY",
    hourAbr: "h",
    hours: "heures",
    minutes: "minutes",
    and: "et",
    trainings: "Formations",
    ofCertifiedAttestations: "d’attestations certifiées",
    season: "Saison",
    essential: "Essentiel",
    cycle: "Cycle",
    congress: "Congré",
    soonLive: "Prochainement en live",
    soonInPerson: "Prochainement en présentiel",
    registerNow: "S'inscrire maintenant",
    register: "S'inscrire",
    buyTraining: "Acheter la formation",
    moreDetails: "Plus de détails",
    program: "Programme",
    buyTheCycle: "Acheter le cycle",
    buyTheSeason: "Acheter la saison",
    buyTheEssential: "Acheter l'essentiel",
    alreadyPremiumSubscribed: "Vous êtes abonné premium",
    premiumSubscription: "Abonnement premium",
    premiumDescription:
      "Accès Live & Replay à toute la bibliothèque oFFFcourse*",
    subscribeToPremium: "S’abonner au premium",
    containsExclusiveEvents:
      "* Comprend exclusivement toutes les formations oFFFcourse en virtuel",
    twelveMonthsCommitment: "Pendant 12 mois, avec engagement",
    year: "an",
    month: "mois",
    monthly: "Mensuel",
    yearly: "Annuel",
    saveAmount: "économisez",
    buyCycle: "Acheter {{definiteLabel}}",
    premiumLabel: "Profitez de + 500 formations",
    oeccbbAdvantage1: "membre de l’OECCBB : ",
    oeccbbAdvantage2: "13ème mois gratuit",
    auth: {
      signInUp: "Connexion / Inscription",
      continue: "Continuer",
      signup: "S’inscrire",
      signin: "Se connecter",
      forgotPassword: "Mot de passe oublié",
      forgot_password: "Oublié?",
      must_accept_conditions:
        "Vous devez accepter nos conditions d'utilisation",
      already_member: "Déjà membre?",
      server_error: "Serveur inaccessible - Re-essayer plus tard",
      error_occurred: "Une erreur est survenue!",
      invalid_credentials: "Identifiants invalides",
      email_address: "Adresse E-mail",
      email: "E-mail",
      firstname: "Prénom",
      lastname: "Nom",
      validate_email: "Veuillez fournir une adresse électronique valide",
      validate_password: "Mot de passe obligatoire",
      required_field: "Ce champ est obligatoire",
      required_2_characters: "Veuillez fournir au moins 2 caractères",
      password_weak: "Le mot de passe est faible !",
      password_not_match: "Veuillez entrez à nouveau la même valeur",
      password: "Mot de passe",
      confirm_password: "Confirmez le mot de passe",
      init_password_p: "Connecté(e) sans mot de passe ?",
      init_password_a: "Créez-le ou réinitialisez-le ici !",
      check_your_email:
        "Veuillez vérifier votre boite email pour valider votre adresse",
      already_sent_email:
        "Nous avons déjà envoyer un email de confirmation dans votre boite.",
      resend_confirmation_email: "Réenvoyer un email de confirmation",
      create_account: "Créer un compte",
      send: "Envoyer",
      password_changed_succesfully: "Mot de passe enregistré avec succés",
      reset_pwd_check_your_email:
        "Un message a été envoyé à votre boîte e-mail. Veuillez le consulter et suivre les instructions.",
      successfully_saved: "Enregistré avec succès",
      complete_personal_infos: "Compléter mon compte personnel",
      mobile_phone_number: "Numéro Téléphone Mobile",
      email_validated_successfully: "Adresse email validée avec succès",
      account_exist_login:
        "Ce compte existe déjà dans l'univers Tamtam:<br/><ul><li><small>- oFFFcouse</small></li><li><small>- United Associates</small></li><li><small>- Forum For the Future</small></li></ul>Veuillez saisir votre mot de passe",
      account_exist_pwd:
        "Ce compte existe déjà dans l'univers Tamtam:<br/><ul><li><small>- oFFFcouse</small></li><li><small>- United Associates</small></li><li><small>- Forum For the Future</small></li></ul>Veuillez définir un mot de passe",
      validate: "Valider",
      male: "Homme",
      female: "Femme",
      gender: "Genre",
      language: "Langue",
      numeroAgreation: "Numéro d'agréation (professions économiques)",
      itaa: "Bureau fiduciaire ITAA",
      ire_audit: "Cabinet d’audit IRE",
      law_office: "Cabinet d’avocats",
      notarial_office: "Cabinet d’étude Notariale",
      university: "Université",
      other: "Autres...",
      validate_phone: "Le numéro de téléphone est invalide",
      uen_label_number: "Saisissez le numéro",
      oldPassword_incorrect: "Ancien mot de passe incorrect",
      email_not_unique: "Adresse e-mail déjà prise",
      cancel: "Annuler",
      reset_password: "Définir le mot de passe",
      french: "Français",
      dutch: "Néerlandais",
      new: "Vous n'avez pas encore de compte ?",
      begin_by: "Commencez par vous",
      subscribe: "inscrire.",
      create_account_ok:
        "La création d'un compte signifie que vous êtes d'accord avec nos ",
      term_of_use: "conditions générales",
      logout: "Se déconnecter",
      invalid_code: "Code invalide",
      login_without_password: "Connexion sans mot de passe",
    },
    on: "sur",
  },
  nl: {
    ARTCILES: "Artikelen",
    Official: "Officieel",
    Manager: "Manager",
    "Legal Reprentative": "Wettelijke vertegenwoordiger",
    "Organization roles": "organisatie rollen",
    "Blog roles": "blog rollen",
    "Editor-in-chief": "Hoofdredacteur",
    CHIEF_EDITOR: "Hoofdredacteur",
    AUTHOR: "Auteur",
    REDACTOR: "Redacteur",
    LEGAL_REPRESENTATIVE: "WETTELIJKE VERTEGENWOORDIGER",
    MANAGER: "MANAGER",
    OFFICIAL: "OFFICIEEL",
    SHAREHOLDER: "AANDEELHOUDER",
    QUALITY_MANAGER: "KWALITEITSMANAGER",
    EXTERNAL: "EXTERNE",
    Mandated: "gemandateerde",
    Not_Mandated: "niet Gemandateerde",
    Details: "Details",
    Join: "Meedoen",
    Replay: "Herhaling",
    Purchase: "Aankoop",
    "Possible to review the training for max 15 days after the date of the live":
      "Mogelijkheid om de training te bekijken tot 15 dagen vanaf de datum van de live",
    Webinar: "Webinar",
    "In progress": "Bezig",
    "Certificate included approved by":
      "Certificaat meegeleverd goedgekeurd door",
    "En Live": "Live",
    see_version: "Zie versie",
    atText: "bij",
    publishedOn: "Gepubliceerd op",
    reading: "Lezen",
    noOptions: "[no options]",
    sharedWith: "[share with]",
    share: "Delen",
    "En Replay": "En Replay",
    add: "Toevoegen",
    quote_text: "Citaattekst invoegen",
    quote_author: "Voeg de auteur van de bronvermelding in",
    write_here: "Schrijf hier ...",
    customize: "Aanpassen",
    customize_dynamic_fields: "Aanpassen met dynamische velden",
    quiz: "Quiz",
    save: "Opslaan",
    offfcourse_library: "oFFFcourse lib",
    replayExpired: "Replay verlopen",
    review: "Beoordeling",
    resume: "Resume",
    play: "Lezing",
    rejoin: "Doe mee",
    participate: "Deelnemen",
    buy: "Kopen",
    details: "Details",
    free: "Gratis",
    subscribed: "U bent geregistreerd",
    subscribedPremium: "Premium abonnee",
    forTheMembers: "voor leden",
    inReplay: "In Replay",
    liveNow: "Nu live",
    seen: "Al Gezien",
    presential: "In-persoon",
    hybrid: "Hybride",
    inLive: "Live",
    dateFrom: "Van",
    timeTo: "tot",
    dateTo: "tot",
    errorOccurred: "Er is een fout opgetreden",
    includedPremium: "Premium inclusief",
    soldOut: "Sold out",
    d: "d",
    h: "u",
    m: "m",
    s: "s",
    includedInSeason: "Maakt deel uit van een seizoen",
    includedInCycle: "Maakt deel uit van een cyclus",
    inPresential: "In-persoon",
    live: "LIVE",
    replay: "REPLAY",
    hourAbr: "u",
    hours: "uren",
    minutes: "minuten",
    and: "en",
    trainings: "Trainingen",
    ofCertifiedAttestations: "geaccrediteerde opleiding",
    season: "Seizoen",
    essential: "Essentieel",
    cycle: "Cyclus",
    congress: "Congres",
    soonLive: "Binnenkort live",
    soonInPerson: "Binnenkort in persoon",
    registerNow: "Registreer nu",
    register: "Registreren",
    buyTraining: "Koop training",
    moreDetails: "Meer details",
    program: "Programma",
    buyTheCycle: "Koop de cyclus",
    buyTheSeason: "Koop het seizoen",
    buyTheEssential: "Koop het essentiële",
    alreadyPremiumSubscribed: "U bent een premium abonnee",
    premiumSubscription: "Premium abonnement",
    premiumDescription:
      "Toegang tot de volledige oFFFcourse bibliotheek, Live & in Replay*",
    subscribeToPremium: "Abonneren op Premium",
    containsExclusiveEvents:
      "* Omvat exclusief alle virtuele cursussen van oFFFcourse",
    twelveMonthsCommitment: "Voor 12 maanden, met verbintenis",
    year: "jaar",
    month: "maand",
    monthly: "Maandelijks",
    yearly: "Jaarlijks",
    saveAmount: "bespaar",
    ofCertifiedAttestations: "geaccrediteerde opleiding",
    buyCycle: "Koop {{definiteLabel}}",
    premiumLabel: "Profiteer van meer dan 500 trainingen",
    oeccbbAdvantage1: "lid van de OECCBB : ",
    oeccbbAdvantage2: "13e maand gratis",
    auth: {
      signInUp: "Inloggen / Registreren",
      continue: "Doorgaan",
      signup: "Aanmelden",
      signin: "Aanmelden",
      forgotPassword: "Uw wachtwoord vergeten",
      forgot_password: "Vergeten?",
      must_accept_conditions: "U moet onze gebruiksvoorwaarden accepteren",
      already_member: "Ben je al lid?",
      server_error: "Server onbereikbaar - Probeer het later opnieuw",
      error_occurred: "Er is een fout opgetreden!",
      invalid_credentials: "Ongeldige inloggegevens",
      email_address: "E-mailadres",
      email: "E-mail",
      firstname: "Voornaam",
      lastname: "Naam",
      validate_email: "Geef een geldig e-mailadres op",
      validate_password: "Vereist wachtwoord",
      required_field: "Dit veld is verplicht",
      required_2_characters: "Geef minimaal 2 tekens op",
      password_weak: "Het wachtwoord is zwak!",
      password_not_match: "Voer dezelfde waarde opnieuw in",
      password: "Wachtwoord",
      confirm_password: "Bevestig wachtwoord",
      init_password_p: "Aangemeld zonder wachtwoord?",
      init_password_a: "hier aan of stel het opnieuw in!",
      check_your_email: "Controleer uw e-mailinbox om uw adres te valideren",
      already_sent_email:
        "We hebben al een bevestigingsmail naar uw inbox gestuurd.",
      resend_confirmation_email: "Een bevestigingsmail opnieuw verzenden",
      create_account: "Account aanmaken",
      send: "Verzenden",
      password_changed_successfully: "Wachtwoord succesvol gewijzigd",
      reset_pwd_check_your_email:
        "Er is een bericht naar uw e-mailinbox verzonden. Controleer het bericht en volg de instructies.",
      successfully_saved: "Succesvol opgeslagen",
      complete_personal_infos: "Mijn persoonlijke account voltooien",
      mobile_phone_number: "Mobiel telefoonnummer",
      email_validated_successfully: "E-mailadres succesvol gevalideerd",
      account_exist_login:
        "Dit account bestaat al in het Tamtam-universum:<br/><ul><li><small>- oFFFcouse</small></li><li><small>- United Associates</small > </li><li><small>- Forum Voor de Toekomst</small></li></ul>Vul uw wachtwoord in",
      account_exist_pwd:
        "Dit account bestaat al in het Tamtam-universum:<br/><ul><li><small>- oFFFcouse</small></li><li><small>- United Associates</small > </li><li><small>- Forum Voor de Toekomst</small></li></ul>Stel een wachtwoord in",
      validate: "Valideren",
      male: "Man",
      female: "Vrouw",
      gender: "Geslacht",
      language: "Taal",
      numeroAgreation: "Overeenkomstnummer (economische beroepen)",
      itaa: "ITAA Trustkantoor",
      ire_audit: "IRE accountantskantoor",
      law_office: "Advocatenkantoor",
      notarial_office: "Notarieel kantoor",
      universiteit: "Universiteit",
      other: "Anders...",
      validate_phone: "Het telefoonnummer is ongeldig",
      uen_label_number: "Voer het nummer in",
      oldPassword_incorrect: "Onjuist oud wachtwoord",
      email_not_unique: "E-mailadres al in gebruik",
      cancel: "Annuleren",
      reset_password: "Wachtwoord instellen",
      french: "Frans",
      dutch: "Nederlands",
      new: "Heeft u nog geen account ?",
      begin_by: "Begin met",
      subscribe: "registreren.",
      create_account_ok:
        "Het aanmaken van een account betekent dat u akkoord gaat met onze ",
      term_of_use: "algemene voorwaarden",
      logout: "Uitloggen",
      invalid_code: "Ongeldige code",
      login_without_password: "Inloggen zonder wachtwoord",
    },
    on: "op",
  },
};
